import { TOGGLE_SIDEBAR } from "../../actions/types";

const initialState = {
  sideBarOpen: false
};

/**
 * Reducer for UI state management
 * @param {Object} state - The current state
 * @param {Object} action - The action object
 * @returns {Object} The new state
 */
const uiStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sideBarOpen: action.payload
      };
    default:
      return state;
  }
};

export default uiStateReducer;